import { BaseModel } from "./base-model.model";

export class Catalog extends BaseModel {
    name: string = '';
    description: string = '';
    itemIds: number[] = [];
}
